import { defineMessages } from "react-intl";

export default defineMessages({
  header: "Din bokning",
  chooseNewTime: "Välj en ny tid för att omboka",
  cancelButton: "Avbryt",
});
